<template>
  <div class="container">
    <CModal
      title="Test has been closed."
      centered
      color="danger"
      :show.sync="warningModal"
      :closeOnBackdrop="false"
    >
      <h4>The test of this topic is closed now.</h4>
      <br />
      <h5>Contact the instructor of your section and try again later.</h5>
      <br />
    </CModal>
    <!-- ปุ่มปิด -->
    <CRow alignHorizontal="end" alignVertical="center">
      <div class="containerIconClose" @click="funcRoute('HP01-1')">
        <font-awesome-icon icon="times" class="IconClose" />
      </div>
    </CRow>

    <CCard class="customCard">
      <CCardHeader class="customCardHeaderActive">
        <CRow
          alignHorizontal="between"
          alignVertical="center"
          class="mr-2 ml-2"
        >
          <h3 :class="checkLangClass() + ' ' + 'm-2'">
            {{ checkLanguage(this.mainContent?.description) }}
          </h3>
        </CRow>
      </CCardHeader>

      <CCardBody v-if="this.mainContent.content">
        <template v-for="(item, index) of this.mainContent.content.nav">
          <CCard class="customCard" :key="index">
            <div v-if="item.item.length > 0">
              <CCardHeader
                v-bind:class="[
                  collapse
                    ? 'customCardHeaderActive bg-blue'
                    : 'customCardHeader bg-blue',
                ]"
                @click="collapse = !collapse"
              >
                <CRow
                  alignHorizontal="between"
                  alignVertical="center"
                  class="mr-2 ml-2"
                >
                  <h3 :class="checkLangClass() + ' ' + 'm-0'">
                    {{ checkLanguage(item.header?.text) }}
                  </h3>
                  <font-awesome-icon
                    class="IconCloseYellow"
                    icon="chevron-down"
                  ></font-awesome-icon>
                </CRow>
              </CCardHeader>
              <CCollapse :show="collapse">
                <CCardBody>
                  <ChapterTable
                    :prevPath="chapterPath"
                    :allItem="item.item"
                    :chapterProgress="topicsProgress"
                    :loading="loading"
                    :showProgressLabel="showProgressLabel"
                  />
                </CCardBody>
              </CCollapse>
            </div>

            <div v-if="item.item.length == 0">
              <CCardHeader
                class="customCardHeader bg-green"
                v-bind:class="[
                  item.header.text[1].value == 'Test'
                    ? 'customCardHeader bg-yellow'
                    : 'customCardHeader bg-green',
                ]"
              >
                <CRow
                  alignHorizontal="between"
                  alignVertical="center"
                  class="mr-2 ml-2"
                >
                  <h3 :class="checkLangClass() + ' ' + 'm-0'">
                    {{ checkLanguage(item.header?.text) }}
                  </h3>
                  <div class="box_progress">
                    <div style="width: 50%">
                      <CProgress show-value height="30px" :value="100">
                        <CProgressBar
                          class="CCProgressBar"
                          :value="getProgress(item.header.text[1].value)"
                        >
                          {{
                            item.header.text[1].value == 'Test'
                              ? progress_test
                              : progress_assignment
                          }}%
                        </CProgressBar>
                      </CProgress>
                    </div>
                    <div style="width: 45%; text-align: end">
                      <CButton
                        class="customCardHeaderButton"
                        shape="pill"
                        @click="
                          openModalFunc(item.header.button[0].action, index)
                        "
                      >
                        <h5 :class="checkLangClass() + ' ' + 'm-0'">
                          {{ checkLanguage(item?.header?.button?.[0]?.text) }}
                        </h5>
                      </CButton>
                    </div>
                  </div>
                </CRow>
              </CCardHeader>
            </div>
          </CCard>
        </template>
      </CCardBody>
    </CCard>
  </div>
</template>
<script>
import ChapterTable from './ChapterTable.vue';
import {mapGetters} from 'vuex';
import '../../../../assets/scss/_chineseStyle.scss';
import '../../../../assets/scss/_chineseIcon.scss';

export default {
  name: 'ChapterSelect',
  components: {
    ChapterTable,
  },
  props: {
    mainContent: Object,
    funcOpenModal: Function,
    funcOpenModalConver: Function,
    cardContent: Object,
    funcCountChat: Function,
    funcRoute: Function,
    chapterProgress: Array,
    pageCode: String,
    checkExam: Array,
    loading: Boolean,
  },
  data() {
    return {
      lessonId: this.$route.params.id,
      chapterPath: '/chapter-select/' + this.lessonId,
      collapse: false,
      cardCollapse: true,
      innerCollapse: false,
      headerText: this.mainContent.title,
      chapterTest: '',
      assignmentText: 'Assignment',
      testText: 'Test',
      lang: '',
      warningModal: false,
      nextRoute: '',
      isClick: false,
      permission_test: false,
      progress_assignment: 0,
      progress_test: 0,
      topicsProgress: [],
      chapterList: [],
    };
  },
  created() {
    this.lang = this.$store.state.language.language;
  },
  mounted() {
    this.$store.commit('courses/setCourseQuizPermissionZero');
  },
  computed: {
    ...mapGetters({
      storeLanguage: 'language/getLanguage',
      getCourseQuizPermission: 'courses/getCourseQuizPermission',
      getChangeTest: 'template/getChangeTest',
      v3LessonLockStatus: 'v3-data/v3LessonLockStatus',
    }),
  },
  watch: {
    chapterProgress: function (val) {
      if (!val) return;
      console.log(val);

      let test_permission = val.filter((item) => {
        if (item.type == 'test') {
          this.progress_test = item.progress;
          return item;
        }
        if (item.type == 'assignment') {
          this.progress_assignment = item.progress;
        }
      });

      // if (test_permission[0].lock) {
      //   this.permission_test = false;
      // } else {
      //   this.permission_test = true;
      // }

      //get allChapterMenu
      const topicItem = this.mainContent.content.nav[0].item;
      this.chapterList = topicItem.map((item) => ({
        number: item.chapter,
      }));
      //
      //filter only topics
      const filteredChapter = val.filter((item) => item.type === 'topic');
      //sort by num
      this.topicsProgress = filteredChapter.sort((a, b) => {
        const getNum = (str) => parseInt(str.split('-')[2], 10);
        return getNum(a.codeItem) - getNum(b.codeItem);
      });
    },
    storeLanguage: function (val) {
      this.lang = val;
    },
    pageCode: function () {},
    // getChangeTest: function (val) {
    //   let openTestStatus = this.$store.getters['template/getTestStatus'];
    //   if (openTestStatus == false) {
    //     this.warningModal = true;
    //   } else {
    //     this.$store.commit('necessary/setMode', {mode: true, type: 'test'});
    //     this.funcRoute(this.nextRoute);
    //   }
    // },
    v3LessonLockStatus: function (val) {
      // console.log(val, 'lesson lock stat');
      if (val.isLock) {
        //this test is lock
        this.warningModal = true;
      } else {
        //test is not lock
        this.funcRoute(this.nextRoute);
      }
    },
  },
  destroyed() {},
  methods: {
    getProgress: function (type) {
      if (type == 'Test') {
        if (this.progress_test <= 30 && this.progress_test > 0) {
          return Math.trunc(25);
        } else if (this.progress_test == 0) {
          return Math.trunc(15);
        } else {
          return Math.trunc(this.progress_test);
        }
      } else {
        if (this.progress_assignment <= 30 && this.progress_assignment > 0) {
          return Math.trunc(25);
        } else if (this.progress_assignment == 0) {
          return Math.trunc(15);
        } else {
          return Math.trunc(this.progress_assignment);
        }
      }
    },
    checkLangClass() {
      if (this.lang == 'CN') {
        return 'fontChinese';
      } else if (this.lang == 'PIN IN') {
        return 'fontPinin';
      } else {
        return '';
      }
    },
    checkLanguage(val) {
      //return nothing when first render is undefined ?
      //need to revised
      if (!val || !Array.isArray(val)) return '';

      for (let i = 0; i <= val.length; i++) {
        if (val[i]?.key === this.lang) {
          return val[i].value;
        }
      }

      return '';
    },
    openModalFunc(path, index) {
      this.nextRoute = path;
      //for test
      if (index == 2) {
        // this.$store.commit('necessary/setTopicID', this.lessonId);
        // this.$store.commit('necessary/setMode', {mode: true, type: 'TEST'});
        // let bodyOfNextRoute = {
        //   code: this.$store.getters['necessary/getCourseObjectId'],
        //   templateCode: path,
        // };
        // this.$store.dispatch(
        //   'template/fetchContentForCheckingPosttest',
        //   bodyOfNextRoute
        // );
        ///
        //get LockData and check isLock
        //if isLock true show modal is close
        //else func route

        const payload = {
          courseId: this.$store.state.v3.v3EnrollData.data.courseinfo,
          section: this.$store.state.v3.v3EnrollData.data.section,
          codeItem: this.$store.state.v3.templates.codeItem,
        };

        this.$store.dispatch('v3-data/v3LessonLockStatus', payload);
      } else {
        //not test
        // this.$store.commit('necessary/setTopicID', this.lessonId);
        // this.$store.commit('necessary/setMode', {
        //   mode: true,
        //   type: 'ASSIGNMENT',
        // });
        // this.$store.commit('necessary/setScoreToZero');
        this.funcRoute(path);
      }
    },
    play() {
      var audio = document.getElementById('audio');
      audio.play();
    },
  },
};
</script>
<style scoped>
.box_progress {
  display: flex;
  width: 20%;
  justify-content: space-between;
  align-items: center;
}
.CCProgressBar {
  background-color: #0f6475;
}
@media screen and (min-width: 300px) and (max-width: 600px) {
  .box_progress {
    justify-content: space-between;
    width: 40%;
  }
}
</style>
